'use client'
import Card from './Card/Card'
import { PreviewBoutiqueGridBlock } from '@/payload-types'
import RichText from '@onclicks/sharedcomponents/RichText'
import { CMSLink } from '../../CMSLink'
import { useFetchProducts } from '@onclicks/sharedmedusa/hooks/useFetchProducts'

const ProductCardsGridTextSide: React.FC<PreviewBoutiqueGridBlock> = (data) => {
  const { title, richText, links, categoryHandle, onlyPromotions } = data

  const { products, loading } = useFetchProducts({
    countryCode: process.env.NEXT_PUBLIC_MEDUSA_REGION ?? 'be',
    categoryHandle,
    limit: 3,
    onlyPromotions: !!onlyPromotions,
  })

  return (
    <section id="products" className="lg:p-16 mt-5 lg:-mt-36">
      <div className="flex flex-col lg:flex-row items-center lg:gap-x-25">
        <div className="mx-auto max-w-2xl lg:shrink-0 text-center lg:text-left">
          {title && <h1 className="text-[#FB7303] text-3xl font-bold">{title}</h1>}
          {richText && (
            <RichText data={richText} enableGutter={false} className="mb-4 text-2xl font-bold" />
          )}
          {links && links.map((link, index) => <CMSLink key={index} {...link.link} />)}
        </div>

        <div className="mx-auto my-8 flex flex-col md:flex-row gap-y-3 items-center justify-center gap-x-6 px-6 lg:px-0 reveal-right">
          {loading
            ? [1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="animate-pulse bg-gray-300 h-48 w-48 rounded-2xl mb-5 flex justify-center items-center"
                />
              ))
            : products.map((product, index) => <Card key={index} product={product} />)}
        </div>
      </div>
    </section>
  )
}

export default ProductCardsGridTextSide
